export const hasBranchId = (user) => {
  const branchId = user?.branchID;
  if (branchId == null) return false;
  if (typeof branchId === "string" && branchId.trim() === "") return false;
  return true;
};

export const resolveUserRoles = (user) => {
  const role = user?.role;
  const position = user?.position;
  const isEmployeeRole = role === "employee";
  const userHasBranch = hasBranchId(user);

  const isCompanyHR = isEmployeeRole && position === "HR" && !userHasBranch;
  const isCompanyManager = isEmployeeRole && position === "Manager" && !userHasBranch;
  const isHR = isEmployeeRole && position === "HR" && userHasBranch;
  const isBranchManager = isEmployeeRole && position === "Manager" && userHasBranch;
  const isAnyHR = isCompanyHR || isHR;
  const isAnyManager = isCompanyManager || isBranchManager;
  const isBranchLevelLeader = isHR || isBranchManager;

  return {
    isCompanyHR,
    isCompanyManager,
    isHR,
    isBranchManager,
    isAnyHR,
    isAnyManager,
    isBranchLevelLeader,
    hasBranchId: userHasBranch,
  };
};
